
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M14.25 7.438L8.988 13.37c-.215.239-.52.376-.842.377H8.14c-.32 0-.624-.135-.839-.371l-3.48-3.83A1.133 1.133 0 115.5 8.024l2.63 2.898 4.427-4.985a1.133 1.133 0 011.709 1.488l-.015.016v-.003zm3.167-3.083a3.937 3.937 0 00-3.283-3.284 54.931 54.931 0 00-10.595 0A3.937 3.937 0 00.256 4.355a54.923 54.923 0 000 10.594 3.936 3.936 0 003.283 3.284c3.524.341 7.072.341 10.595 0a3.936 3.936 0 003.283-3.284c.342-3.524.342-7.071 0-10.594z","fill":"#D551AD"}}),_c('path',{attrs:{"d":"M14.25 7.438L8.988 13.37c-.215.239-.52.376-.842.377H8.14c-.32 0-.624-.135-.839-.371l-3.48-3.83A1.133 1.133 0 115.5 8.024l2.63 2.898 4.427-4.985a1.133 1.133 0 011.709 1.488l-.015.016v-.003z","fill":"#FFF"}})])])
          )
        }
      }
    